import "../../css/pages/industry.scss";
import BasePage from "./base";
import slashImageBlock from "../modules/slashImageBlock";
import tabsToggle from "../modules/tabsToggle";
import capabilities from "../modules/capabilities";
import relatedInsights from "../modules/relatedInsights";
import accordion from "../modules/accordion";
import sectionNavV3 from "../modules/sectionNavV3";
import anchorSets from "../modules/anchorSets";
import relatedCases from "../modules/relatedCases";
import homepageIndustries from "../modules/homepageIndustries";
import largeCardCarousel from "../modules/largeCardCarousel";
import executiveLeadership from "../modules/leader";

class IndustryPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        tabsToggle.init();
        capabilities.init();
        relatedInsights.init();
        window.addEventListener("load", accordion.init);
        sectionNavV3.init();
        anchorSets.init();
        relatedCases.init();
        homepageIndustries.init();
        largeCardCarousel.init();
        executiveLeadership.init();
        slashImageBlock.init();
    }
}

new IndustryPage();
